import Vue from "vue";
import Router from "vue-router";

import anniversary from "./anniversary";
import secondAnniversary from "./secondAnniversary";

Vue.use(Router);

const router = new Router({
    mode: "history",
    base: "/ares",
    routes: [
        ...anniversary,
        ...secondAnniversary,
    ],
});

export default router;


// WEBPACK FOOTER //
// ./src/router/ares/index.js